$(function() {
    $('[data-toggle="tooltip"]').tooltip();

    /** Show error message at the top of the page */
    $('.show-popup').click(function() {
        var showId = '#'+$(this).data('show-id');
        $(showId).fadeIn();
        setTimeout(function(){$(showId).fadeOut();}, 3000);
    });

    if ($('.with-eye').length) {
        $('.with-eye').protectedInput({
            eyeSlashClass:'fcml-eye-slash',
            eyeClass:'fcml-eye'
        });
    }

    $('input[type="text"][name="amount"]').prop('disabled', false);

    $('[data-ignore-when-fill]').on('input', function () {
        var toDisabled = $(this).data('ignore-when-fill'),
            same = $(`[data-ignore-when-fill="${toDisabled}"]`),
            disabled = false;
        same.map(function (indx, item) {
            disabled = disabled || $(item).val().length;
        });
        $(toDisabled).prop('disabled', disabled);
    });
    $('[data-ignore-when-fill]').trigger('input');

    $('input[data-type]').on('keydown', function(event) {
        if (['Backspace', 'Enter', 'Tab', 'Delete'].indexOf(event.key) !== -1) {
            return true;
        }
        if (event.key && event.key.search("Arrow") !== -1) {
            return true;
        }
        if (event.ctrlKey) {
            return true;
        }
        if ($(this).data('type') == 'amount') {
            return typeAmountHandler.call(this, event);
        }
        return true;
    });

    $('input[data-type]').on('paste', function (event) {
        if ($(this).data('type') == 'amount') {
            return pasteAmountHandler.call(this, event);
        }
    });

    function pasteAmountHandler(event) {
        var self = this;
        let patterns = [
            /[1-9]{1}[0-9]{0,11}/,
            /[0]{1}(?:\.|\,)(?:\d{1,8})/,
            /(?:[1-9]{1}[0-9]{0,11})(?:\.|\,)(?:\d{1,8})?/,
        ];
        setTimeout(function () {
            var value = $(self).val(),
                result = '',
                match = [];
            for (let i = 0; i < patterns.length; i++) {
                match = value.match(patterns[i]);
                if (match && match.length) {
                    result = match[0];
                }
            }
            $(self).val(result);
        }, 1);
    }

    function typeAmountHandler(event) {
        let patterns =  [
            /^[1-9][0-9]{0,11}$/, // 1 | 123
            /^0$/, // 0
            /^\.\d{0,8}$/, // .123 | .
            /^(?:0?|[1-9][0-9]{0,11})[.,](?:\d{1,8})?$/,
        ];
        let selectionStart = event.currentTarget.selectionStart,
            selectionEnd = event.currentTarget.selectionEnd,
            rawValue = event.currentTarget.value,
            value = `${rawValue.substr(0, selectionStart)}${event.key}${rawValue.substr(selectionEnd, rawValue.length)}`;

        for (let i = 0; i < patterns.length; i++) {
            if (!!value.match(patterns[i])) {
                return true;
            }
        }
        return false;
    }
});
